<template>
	<div class="home">
		<div class="black_modal" :class="{'isLogin':isLoginStatu}">
			<i class="el-icon-loading"></i>
		</div>
		<HeaderTab :type="type" :userInfo='userInfo' />
		<Favorites />
		<BookModal :modalData="modalData">
			<span slot="header_4">Tips</span>
		</BookModal>
	</div>
</template>

<script>
	// @ is an alias to /src
	import {
		mapState
	} from 'vuex'
	import HeaderTab from "@/components/HeaderTab.vue"
	import Favorites from "@/components/home/Favorites.vue"
	import BookModal from "@/components/Modal.vue"

	export default {
		name: "Home",
		data() {
			return {
				type: 'home',
				isLoginStatu: false
			}
		},
		components: {
			Favorites,
			HeaderTab,
			BookModal
		},
		created() {
			this.isLogin()
			this.removeLocalStorgeRole()
		},
		computed: mapState({
			modalData: state => state.home.modalData,
			userInfo: state => state.home.userInfo,
		}),
		methods: {
			removeLocalStorgeRole() {
				localStorage.removeItem('role_list')
				localStorage.removeItem('previewData')
				Object.keys(localStorage).forEach(item => item.indexOf('option_') !== -1 ? localStorage.removeItem(item) : '')
			},
			loadBookList() {
				this.getAxios('/h5/getMyWriterBookList', {
					page: 1
				}).then((data) => {
					if (data.data.length > 0) {
						this.$store.commit('home/renderBookList', data.data)
					}
				}, (err) => {
					// handle authorization error
				});
			},
			isLogin() {
				this.getAxios('/h5/getUserInfo').then((data) => {
					if (data.code === 910) {
						Passport.show(module)
					}
					if (data.code === 200) {
						this.isLoginStatu = true
						this.$store.commit('home/renderUserInfo', data.data.user_info)
						this.loadBookList()
					}
				}, (err) => {
					// handle authorization error
				})
				Passport.on('loginSuccess', function() {})
				Passport.on('switchIggId', function() {
					location.reload()
				})
				Passport.on('hideInfo', function() {
					location.reload()
				})
			}
		}
	};
</script>

<style lang="scss">
	.home {
		width: 640px;
		margin: 0 auto;
		
		.black_modal {
			position: fixed;
			left: 0;
			top: 0;
			width: 100%;
			height: 100vh;
			background: rgb(0 0 0 / 65%);
			z-index: 10;
			// display: none;
			display: flex;
			align-items: center;
			justify-content: center;
			&.isLogin {
				display: none;
			}
			i.el-icon-loading {
				color: #fff;
				font-size: 40px;
			}
		}

		.tabCheck {
			.el-tabs__nav {
				float: none;
			}

			.el-tabs__item {
				width: 50%;
				text-align: center;
				font-size: 22px;
				height: 60px;
				line-height: 60px;
			}
		}

		.smallImg {
			height: 130px;
		}
	}

	#igg_passport .passport--frame-close {
		display: none!important;
	}

	.favorites-box {
		padding: 0 10px;

		.title {
			font-size: 22px;
			font-weight: bold;
			padding: 20px 0 20px 10px;

			i {
				padding-right: 10px;
			}
		}

		ul {
			display: flex;
			flex-wrap: wrap;

			li {
				padding: 0 12px 20px;
				text-align: center;
				color: #303030;
				font-size: 14px;
				position: relative;

				.el-image {
					border-radius: 0 12px 0 12px;
				}

				span {
					line-height: 16px;
					display: block;
					width: 100px;
					word-wrap: break-word
				}

				i.el-icon-close {
					position: absolute;
					right: 20px;
					top: 5px;
					color: #fff;
					background: rgb(0 0 0 / 40%);
					border-radius: 20px;
					padding: 2px;
					font-size: 14px;
					font-weight: bold;
					display: none;
				}

				&:hover {
					cursor: pointer;

					i.el-icon-close {
						display: inline-block;
					}
				}

				.crear-box {
					background-color: #fec5a5;
					height: 130px;
					border-radius: 0 12px 0 12px;
					color: #fff;
					width: 100px;

					i {
						margin: 10px 10px 0 0;
						font-size: 30px;
						float: right;
					}

					.crear-box-text {
						box-sizing: border-box;
						font-size: 14px;
						font-weight: 400;
						letter-spacing: 0.06em;
						width: 100%;
						height: 90px;
						line-height: 18px;
						padding: 0 20px;
						display: flex;
						align-items: center;
						justify-content: space-around;
						flex-direction: column;

						em {
							font-style: normal;
							font-weight: bold;
						}
					}
				}
			}
		}
	}
	#igg_passport .passport--frame-close {
		display: none;
	}
</style>
